module.exports = __webpack_public_path__ + "img/flourish-logotipo.2198eea5.png";